export default "__VITE_ASSET__0b3d3fd9__"